import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { TenantSelectorService } from 'app/services/tenant-selector.service';
import {ConfigsLoaderService} from '../../services/config-loader.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private authService: AuthService,
              private selectorTenant: TenantSelectorService,
              private config: ConfigsLoaderService,
  ) {
  }
  // tslint:disable-next-line: no-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authService.isLoggedIn())
      .pipe(
        switchMap(isLoggedIn => { // do the changes here
          const applicationId = '' + this.config.applicationId;
          let clonedReq = req.clone();
          if (isLoggedIn) {

            const applicationId = '' + this.config.applicationId;
            let clonedReq = req.clone();

            if (this.authService.currentUser?.tenantId) {
              const tenantId = this.authService.currentUser.tenantId.toString();
              const selectedTenantId = JSON.parse(MVLocalStorageService.getItem('selected_tenant'))?.id ?? tenantId;

              clonedReq = req.clone({
                headers: req.headers.set('Authorization', this.authService.getAuthorizationHeaderValue())
                  .set('TenantId', tenantId)
                  .set('ApplicationId', applicationId)
                  .set('SelectedTenantId', selectedTenantId)
              });
            } else {
              clonedReq = req.clone({
                headers: req.headers
                  .set('ApplicationId', applicationId)
              });
            }
            //Set and send selectedLanguageId header just is not undefined
            if(MVLocalStorageService.getItem('selected_lang') && MVLocalStorageService.getItem('selected_lang') != 'undefined'){
              const selectedLanguageId = (JSON.parse(MVLocalStorageService.getItem('selected_lang')));
              clonedReq = clonedReq.clone({
                headers: clonedReq.headers.set('SelectedLanguageId', (selectedLanguageId.id).toString())
              });
            }
            
            return next.handle(clonedReq).pipe(
              tap(
                succ => { },
                err => {
                  if (err.status === 401) {
                    this.authService.logout();
                  }
                }
              )
            );
          } else {
            clonedReq = req.clone({
              headers: req.headers
                .set('ApplicationId', applicationId)
            });//Set and send selectedLanguageId header just is not undefined
            if(MVLocalStorageService.getItem('selected_lang') && MVLocalStorageService.getItem('selected_lang') != 'undefined'){
              const selectedLanguageId = (JSON.parse(MVLocalStorageService.getItem('selected_lang'))).toString();
              clonedReq = clonedReq.clone({
                headers: clonedReq.headers.set('SelectedLanguageId', selectedLanguageId)
              });
            }
            return next.handle(clonedReq);
          }
        })
      );
  }
}
